import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';

const TextSection = () => (
    <div className="text-section block-section">
        <Grid>
            <Row>
                <Col lg={8} lgOffset={4}>

                    <div className="text-section__content">
                        <div className="text-section__text"><p>Located in Bandung, <strong>Hubton Indonesia</strong>, a website design and development studio, has served clients from all over the globe. We strive to give world-class quality website to clients from various sectors. Small or big. Corporate or start-ups. We’d love to work with you.</p>
                            <p>Since digital evolution has brought us to the era when screens are human’s second nature, brands who can deliver the best digital experience, can easily win half the battle.</p>
                            <p>You in?</p>
                        </div>

                        <a href="https://hubton.com/about" className="text-section__link">
                            Learn More About Us →
                        </a>
                    </div>

                </Col>
            </Row>
        </Grid>
    </div>
);

export default TextSection;


// WEBPACK FOOTER //
// ./src/containers/Home/TextSection.js